<template>
  <div>
    <progress-state
      v-if="hasFailed"
      variant="failed"
      title="No pudimos cargar tu actividad"
      text="Fue un problema temporal al consultar tus niveles."
      :is-retrying="isRetrying"
      @retry="load()"
    />

    <div class="m-section" v-else-if="!isLoadingDays">
      <div class="m-section__header">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-9 col-12">
            <div class="m-section__headline">
              Tus ingresos On Demand
              <span class="m-section__date ml-2" v-if="readableRange">{{ readableRange }}</span>
            </div>
          </div>
          <div class="col-md-auto col-12">
            <div class="m-section__filter-date">
              Periodo:
              <span class="ml-1">
                <select v-model="selectedRange" class="form-control w-auto">
                  <option :value="FORTNIGHT_RANGE">Última quincena</option>
                  <option :value="LAST_MONTH_RANGE">Últimos 30 días</option>
                </select>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-6">
          <CardIncome
            :data="activitySummary.orders"
            :name="'orders'"
            :action="true"
            :title="'Pedidos'"
            :url="'/foodcourt/pedidos'"
          />
        </div>
        <div class="col-md-3 col-6">
          <CardIncome
            :data="activitySummary.claims"
            :name="'claims'"
            :action="true"
            :title="'Reclamos'"
            :url="'/foodcourt/claims'"
          />
        </div>
        <div class="col-md-6 col-12">
          <div class="m-card">
            <div class="m-card__header">
              <div class="title-c">Ingresos</div>
            </div>
            <div class="m-card__main">
              <div class="letter letter--pending">Próximamente</div>
            </div>
            <div class="m-card__footer">
              <div>
                La liquidación de On Demand aún no tiene un cálculo propio; se está construyendo.
                Mientras tanto, revisá tus
                <router-link to="/foodcourt/cargos">cargos</router-link> y tus
                <router-link to="/foodcourt/niveles">niveles</router-link>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-content-loading
      v-else
      :width="300"
      :height="85"
      primary="#bdc3c7"
      secondary="#95a5a6"
    >
      <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="8" />
      <svg:rect x="90" y="0" rx="3" ry="3" width="50" height="8" />

      <svg:rect x="0" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="79" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="157" y="17" rx="3" ry="3" width="65" height="55" />
      <svg:rect x="235" y="17" rx="3" ry="3" width="65" height="55" />
    </vue-content-loading>
  </div>
</template>

<script>
import moment from 'moment'
import { VueContentLoading } from 'vue-content-loading'
import { mapActions, mapGetters } from 'vuex'
import CardIncome from '@/components/Metrics/CardIncome'
import ProgressState from './OnDemandProgress/ProgressState'
import { FORTNIGHT_RANGE, LAST_MONTH_RANGE } from '@/store/modules/foodcourtLevels'

const ISO_DATE_FORMAT = 'YYYY-MM-DD'
const DAY_MONTH_FORMAT = 'DD/MM'

export default {
  name: 'OnDemandActivity',
  components: { CardIncome, ProgressState, VueContentLoading },
  data () {
    return {
      FORTNIGHT_RANGE,
      LAST_MONTH_RANGE,
      hasFailed: false,
      isRetrying: false
    }
  },
  async created () {
    await this.load()
  },
  computed: {
    ...mapGetters('foodcourtLevels', [
      'isLoadingDays',
      'getDaysRange',
      'getActivitySummary',
      'getSelectedDaysRange'
    ]),

    activitySummary () {
      return this.getActivitySummary
    },

    selectedRange: {
      get () {
        return this.getSelectedDaysRange
      },
      set (range) {
        this.load(range)
      }
    },

    readableRange () {
      const range = this.getDaysRange
      if (!range.from || !range.to) return ''
      return (
        'Del ' +
        moment(range.from, ISO_DATE_FORMAT).format(DAY_MONTH_FORMAT) +
        ' al ' +
        moment(range.to, ISO_DATE_FORMAT).format(DAY_MONTH_FORMAT)
      )
    }
  },
  methods: {
    ...mapActions('foodcourtLevels', ['SELECT_DAYS_RANGE']),

    async load (range) {
      this.isRetrying = true
      this.hasFailed = false
      try {
        await this.SELECT_DAYS_RANGE(range || this.getSelectedDaysRange)
      } catch (error) {
        this.hasFailed = true
      } finally {
        this.isRetrying = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.letter--pending {
  color: #8898aa !important;
}
</style>
